export const rolesGrantCheck = (roles, userGrants, user) => {
  return roles.some(r => userGrants.includes(r));
};
